import { isInstanceOf, isTypeOrUndefined, isVertexKey, } from "./aux";
import { isArray, isString, isObject, isNumber, isColor, } from "./wsi4_typeguards";
function isAddSuccess(t) {
    const typeGuardMap = {
        tag: (arg) => arg === "AddSuccess",
        importId: isString,
        vertexKeys: (arg) => isArray(arg, isVertexKey),
    };
    return isInstanceOf(t, typeGuardMap);
}
function isLayerViewData(t) {
    const typeGuardMap = {
        descriptor: isNumber,
        name: isString,
        svg: isString,
        color: (arg) => isTypeOrUndefined(arg, isColor),
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isInvalidLayered(t) {
    const typeGuardMap = {
        tag: (arg) => arg === "InvalidLayered",
        cuttingLds: (arg) => isArray(arg, isNumber),
        engravingLds: (arg) => isArray(arg, isNumber),
        importId: isString,
        layerViewDatas: (arg) => isArray(arg, isLayerViewData),
        layered: (arg) => isObject(arg),
        name: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isInvalidInput(t) {
    const typeGuardMap = {
        tag: (arg) => arg === "InvalidInput",
        importId: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isExternalAddResult(t) {
    return isAddSuccess(t) || isInvalidLayered(t) || isInvalidInput(t);
}
